import React, { useEffect, useRef, useState } from "react";
import "../../css/components/CustomSelect.css";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow_down.svg";

export default function CustomSelect({
  options = [],
  value = "",
  onChange,
  name = "",
  placeholder = "Please select",
  className = "",
}) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const selectedOption = options.find((option) => option.value === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (optionValue) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: optionValue,
        },
      });
    }
    setIsOpen(false);
  };

  return (
    <div ref={wrapperRef} className={`custom-select ${className}`}>
      <button
        type="button"
        className={`custom-select-trigger ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="custom-select-text">
          {selectedOption?.label || placeholder}
        </span>
        <span className={`custom-select-arrow ${isOpen ? "open" : ""}`}>
          <ArrowDown />
        </span>
      </button>

      {isOpen && (
        <div className="custom-select-dropdown">
          {options.map((option) => {
            const isSelected = option.value === value;

            return (
              <button
                key={option.value || option.label}
                type="button"
                className={`custom-select-option ${
                  isSelected ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
